export const API_URL = process.env.MIX_API_URL ?? "http://localhost:8033/api";

export const AUTH_TOKEN_NAME = "tdd_token";
export const AUTH_USER_NAME = "tdd_user";
export const AUTH_ROLE_ID = "tdd_role_id";


export const IS_PRODUCTION = process.env.MIX_IS_PRODUCTION == 'true' ?? false;
